import { render, staticRenderFns } from "./BaseScreen.vue?vue&type=template&id=012810b0&"
import script from "./BaseScreen.vue?vue&type=script&lang=js&"
export * from "./BaseScreen.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports